export default class Announcement {
  constructor(id, content, startDate, startEnd) {
    this.id = id;
    this.content = content;
    this.startDate = startDate;
    this.startEnd = startEnd;
  }

  static build({ id, content, startDate, startEnd }) {
    return new Announcement(id, content, startDate, startEnd);
  }

  static parse(value) {
    return value ? Announcement.build({
      id: value.id,
      content: value.content,
      startDate: value.startDate,
      startEnd: value.startEnd
    }) : null;
  }

  toJSON() {
    return {
      id: this.id !== undefined || this.id !== '' ? this.id : null,
      content: this.content !== undefined || this.content !== '' ? this.content : null,
      startDate: this.startDate !== undefined || this.startDate !== '' ? this.startDate : null,
      startEnd: this.startEnd !== undefined || this.startEnd !== '' ? this.startEnd : null
    };
  }
}
